import Tab from '@mui/material/Tab';
import { styled } from '@mui/material/styles';

/** 18px sentence-case tab; `iconOnly` shrinks it to its icon and sets it off with a short divider on the right. */
export const LargeTab = styled(Tab, {
  shouldForwardProp: prop => prop !== 'iconOnly',
})<{ iconOnly?: boolean }>(({ theme, iconOnly }) => ({
  textTransform: 'none',
  fontSize: 18,
  fontWeight: theme.typography.fontWeightMedium,
  ...(iconOnly && {
    minWidth: 'auto',
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    marginRight: theme.spacing(1),
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      right: 0,
      top: '20%',
      bottom: '20%',
      width: '1px',
      backgroundColor: theme.palette.divider,
    },
  }),
}));
